/* Sowth premium PDP — universal variant engine + interactions.
   Reads config from <script id="spdp-data" type="application/json">. No Liquid here. */
(function () {
  'use strict';
  var root = document.querySelector('.spdp');
  if (!root) return;
  var dataEl = document.getElementById('spdp-data');
  var CFG = {};
  try { CFG = JSON.parse(dataEl.textContent); } catch (e) { CFG = {}; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $all = function (s, c) { return [].slice.call((c || root).querySelectorAll(s)); };

  /* ---------- analytics bridge ----------
     The custom variant engine adds via raw /cart/add.js and changes variants in JS, so it must
     feed Shopify's analytics itself. Publishing Dawn's cartUpdate fires AddToCart for the Meta/
     TikTok web pixels + the cart listener; syncing ShopifyAnalytics.meta.selectedVariantId keeps
     ViewContent (product_viewed) on the right variant and stops shop_events_listener.js throwing
     on an undefined variant.options. */
  function pubCartUpdate(source, id, data) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: source, productVariantId: String(id), cartData: data });
      }
    } catch (e) {}
  }
  function syncAnalyticsVariant(v) {
    try { if (v && window.ShopifyAnalytics && ShopifyAnalytics.meta) ShopifyAnalytics.meta.selectedVariantId = v.id; } catch (e) {}
  }

  /* ---------- reveal ---------- */
  if ('IntersectionObserver' in window && !reduce) {
    document.documentElement.classList.add('spdp-js');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    var revEls = $all('.r, .stagger');
    revEls.forEach(function (el) { io.observe(el); });
    /* Failsafe: never leave content hidden if IntersectionObserver never fires
       (headless renderer, throttled tab). */
    setTimeout(function () { revEls.forEach(function (el) { if (!el.classList.contains('in')) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight * 1.25) el.classList.add('in'); } }); }, 600);
    setTimeout(function () { revEls.forEach(function (el) { el.classList.add('in'); }); }, 2600);
  }

  /* ---------- accordions ---------- */
  $all('.acc__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var i = q.closest('.acc__item');
      if (i) { var open = i.classList.toggle('open'); q.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    });
  });

  /* ---------- qty steppers ---------- */
  $all('.qty').forEach(function (q) {
    var inp = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(inp.value, 10) || 1; v += btn.dataset.step === '-1' ? -1 : 1; inp.value = Math.max(1, v);
      });
    });
  });

  /* ---------- gallery ---------- */
  var gal = $('[data-gallery]'), mainImg = $('[data-main]');
  function setMain(src, alt) {
    if (!mainImg || !src) return;
    mainImg.setAttribute('src', src);
    if (alt) mainImg.setAttribute('alt', alt);
    $all('.gal__thumb').forEach(function (t) {
      var ti = t.querySelector('img');
      t.classList.toggle('active', ti && (ti.getAttribute('data-full') || ti.getAttribute('src')) === src);
    });
  }
  $all('.gal__thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var im = t.querySelector('img'); if (!im) return;
      /* Load the high-res image into the stage, NOT the 160px thumbnail src (which would upscale and blur). */
      setMain(im.getAttribute('data-full') || im.getAttribute('src'), im.getAttribute('alt'));
    });
  });

  /* ---------- variant engine (universal) ---------- */
  var variants = CFG.variants || [];
  var options = CFG.options || [];
  function money(cents) { // fallback only; formatted strings come from Liquid
    return '$' + (cents / 100).toFixed(2);
  }
  function findVariant(sel) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < sel.length; j++) { if (v.options[j] !== sel[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function firstAvailableWith(idx, value) {
    for (var i = 0; i < variants.length; i++) { if (variants[i].options[idx] === value && variants[i].available) return variants[i]; }
    return null;
  }

  // init selection from the first available variant, else first variant
  var initV = null;
  for (var i = 0; i < variants.length; i++) { if (variants[i].available) { initV = variants[i]; break; } }
  if (!initV) initV = variants[0];
  var selected = initV ? initV.options.slice() : [];

  // refs
  var priceNow = $('[data-price-now]'), priceWas = $('[data-price-was]'), priceSave = $('[data-price-save]'),
      atc = $('[data-atc]'), atcText = $('[data-atc-text]'), atcId = $('[data-atc-id]'),
      stickyImg = $('[data-sticky-img]'), stickyTitle = $('[data-sticky-title]'),
      stickyNow = $('[data-sticky-now]'), stickyWas = $('[data-sticky-was]'), stickyCta = $('[data-sticky-cta]'),
      stickyAtc = $('[data-sticky-atc]'),
      colorName = $('[data-color-name]'),
      galTag = $('[data-gal-tag]'),
      lowStock = $('[data-lowstock]'), lowStockText = $('[data-lowstock-text]');
  var BUNDLE_DISCOUNT_MIN_CENTS = 9000; // the live "10% off orders over $90" threshold
  var LOW_THRESHOLD = typeof CFG.lowStockThreshold === 'number' ? CFG.lowStockThreshold : 0;

  function variantImg(v) {
    if (v && v.image) return v.image;
    return mainImg ? mainImg.getAttribute('src') : '';
  }

  function selectValue(idx, value) {
    selected[idx] = value;
    var v = findVariant(selected);
    if (!v || !v.available) {
      var alt = firstAvailableWith(idx, value);
      if (alt) selected = alt.options.slice();
    }
    render();
  }

  // wire option controls (rendered server-side in Liquid)
  $all('[data-option-group]').forEach(function (group) {
    var idx = parseInt(group.getAttribute('data-option-group'), 10);
    group.querySelectorAll('[data-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        selectValue(idx, btn.getAttribute('data-value'));
      });
    });
  });

  function render() {
    var v = findVariant(selected);
    var available = !!(v && v.available);

    // option controls: active + availability (a value is sold-out if the resulting combo is unavailable)
    $all('[data-option-group]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-group'), 10);
      group.querySelectorAll('[data-value]').forEach(function (btn) {
        var val = btn.getAttribute('data-value');
        var probe = selected.slice(); probe[idx] = val;
        var pv = findVariant(probe);
        var ok = !!(pv && pv.available);
        btn.classList.toggle('active', selected[idx] === val);
        btn.classList.toggle('soldout', !ok && btn.classList.contains('swatch'));
        btn.classList.toggle('is-sold', !ok && btn.classList.contains('cswatch'));
        // keep sold-out values clickable for exploration, but announce state to assistive tech
        btn.setAttribute('aria-pressed', selected[idx] === val ? 'true' : 'false');
        if (ok) { btn.removeAttribute('aria-disabled'); } else { btn.setAttribute('aria-disabled', 'true'); }
        if (btn.classList.contains('cswatch')) { btn.setAttribute('aria-label', val + (ok ? '' : ' (sold out)')); }
      });
    });
    if (colorName && CFG.colorIndex > -1) colorName.textContent = selected[CFG.colorIndex] || '';

    // image
    if (v) setMain(variantImg(v), CFG.title + (CFG.colorIndex > -1 ? ', ' + selected[CFG.colorIndex] : ''));

    // price + compare + save
    if (v && priceNow) {
      priceNow.textContent = v.price;
      if (v.compareCents && v.compareCents > v.priceCents) {
        var pct = Math.round((v.compareCents - v.priceCents) / v.compareCents * 100);
        if (priceWas) { priceWas.textContent = v.compare; priceWas.style.display = ''; }
        if (priceSave) { priceSave.textContent = 'Save ' + pct + '%'; priceSave.style.display = ''; }
      } else {
        if (priceWas) priceWas.style.display = 'none';
        if (priceSave) priceSave.style.display = 'none';
      }
    }

    // add-to-cart state
    function setAtc(btn, txtEl, cta) {
      if (!btn) return;
      var ico = btn.querySelector('.ico');
      if (available) {
        btn.classList.remove('is-sold'); btn.disabled = false; btn.removeAttribute('aria-disabled');
        if (ico) ico.style.display = '';
        if (atcId && btn === atc) atcId.value = v.id;
        btn.dataset.variantId = v.id;
        if (txtEl) txtEl.textContent = 'Add to cart · ' + v.price;
        if (cta) cta.textContent = 'Add to cart';
      } else {
        // native disabled (not just aria) + drop the forward arrow on the Sold out state
        btn.classList.add('is-sold'); btn.disabled = true; btn.setAttribute('aria-disabled', 'true');
        if (ico) ico.style.display = 'none';
        if (txtEl) txtEl.textContent = 'Sold out';
        if (cta) cta.textContent = 'Sold out';
      }
    }
    setAtc(atc, atcText, null);
    setAtc(stickyAtc, null, stickyCta);

    // keep the image "Save %" overlay badge in sync with the selected variant (was static Liquid)
    if (galTag) {
      if (v && v.compareCents && v.compareCents > v.priceCents) {
        var gpct = Math.round((v.compareCents - v.priceCents) / v.compareCents * 100);
        galTag.textContent = 'Save ' + gpct + '%';
        galTag.hidden = false;
      } else if (/^save/i.test(galTag.textContent || '')) {
        galTag.hidden = true; // was a discount badge, this variant isn't discounted
      }
    }

    // honest low-stock nudge: only for tracked, sell-when-zero-off variants with real low count
    if (lowStock) {
      var inv = v && typeof v.inv === 'number' ? v.inv : null;
      if (available && LOW_THRESHOLD > 0 && inv !== null && inv > 0 && inv <= LOW_THRESHOLD) {
        if (lowStockText) lowStockText.textContent = inv === 1 ? 'Only 1 left in this option' : 'Only ' + inv + ' left in this option';
        lowStock.hidden = false;
      } else {
        lowStock.hidden = true;
      }
    }

    // sticky mirror
    if (stickyImg && v) stickyImg.setAttribute('src', variantImg(v));
    if (stickyTitle) stickyTitle.textContent = CFG.title + (v && v.title && v.title !== 'Default Title' ? ' · ' + v.title : '');
    if (stickyNow && v) stickyNow.textContent = v.price;
    if (stickyWas && v) {
      if (v.compareCents && v.compareCents > v.priceCents) { stickyWas.textContent = v.compare; stickyWas.style.display = ''; }
      else stickyWas.style.display = 'none';
    }

    // bundle (self portion follows the selected variant)
    renderBundle(v);
    // expose for analytics / debugging + keep Shopify analytics on the current variant (ViewContent)
    root.dataset.currentVariant = v ? v.id : '';
    syncAnalyticsVariant(v);
  }

  /* ---------- bundle: self follows variant, companions from <select> ---------- */
  var bundleSelfImg = $('[data-bundle-self-img]'), bundleSelfPrice = $('[data-bundle-self-price]'),
      bundleSelfChip = $('[data-bundle-self-chip]'),
      bNow = $('[data-bundle-now]'), bWas = $('[data-bundle-was]'), bSave = $('[data-bundle-save]'),
      bundleAdd = $('[data-bundle-add]');
  var compSelects = $all('[data-bundle-comp]');
  compSelects.forEach(function (sel) {
    sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      var pe = sel.closest('.setup__bi').querySelector('[data-comp-price]');
      var im = sel.closest('.setup__bi').querySelector('[data-comp-img]');
      if (pe && o.getAttribute('data-price')) pe.textContent = o.getAttribute('data-price');
      if (im && o.getAttribute('data-img')) im.setAttribute('src', o.getAttribute('data-img'));
      var cv = findVariant(selected); renderBundle(cv);
    });
  });
  function renderBundle(v) {
    if (!bNow || !v) return;
    if (bundleSelfImg) bundleSelfImg.setAttribute('src', variantImg(v));
    if (bundleSelfPrice) bundleSelfPrice.textContent = v.price;
    if (bundleSelfChip) bundleSelfChip.textContent = (v.title && v.title !== 'Default Title') ? 'Your pick' : 'This item';
    var nowC = v.priceCents, wasC = (v.compareCents && v.compareCents > v.priceCents) ? v.compareCents : v.priceCents;
    var ids = [v.id];
    compSelects.forEach(function (sel) {
      var o = sel.options[sel.selectedIndex]; if (!o) return;
      nowC += parseInt(o.getAttribute('data-price-cents'), 10) || 0;
      wasC += parseInt(o.getAttribute('data-compare-cents') || o.getAttribute('data-price-cents'), 10) || 0;
      if (o.getAttribute('data-id')) ids.push(o.getAttribute('data-id'));
    });
    bNow.textContent = money(nowC);
    if (bWas) { if (wasC > nowC) { bWas.textContent = money(wasC); bWas.style.display = ''; } else bWas.style.display = 'none'; }
    if (bSave) {
      // The extra 10% is real only when an automatic discount actually fires: either the
      // "Complete the Setup bundle" discount (3+ items) or "10% off orders over $90".
      var s = wasC - nowC;
      var qualifies = ids.length >= 3 || nowC >= BUNDLE_DISCOUNT_MIN_CENTS;
      if (s > 0 && qualifies) bSave.textContent = 'You save ' + money(s) + ', plus 10% in cart';
      else if (s > 0) bSave.textContent = 'You save ' + money(s);
      else if (qualifies) bSave.textContent = 'Plus 10% off in cart';
      else bSave.textContent = '';
      bSave.style.display = bSave.textContent ? '' : 'none';
    }
    if (bundleAdd) {
      var link = '/cart/' + ids.map(function (id) { return id + ':1'; }).join(',');
      bundleAdd.setAttribute('href', link);
    }
  }

  if (variants.length) render();

  /* ---------- AJAX add to cart ---------- */
  function ajaxAdd(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    });
  }
  function refreshCartBubble() {
    fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      if (s && s['cart-icon-bubble']) { var d = document.getElementById('cart-icon-bubble'); if (d) d.innerHTML = s['cart-icon-bubble']; }
    }).catch(function () {});
  }
  function wireAtc(btn, qtyInput) {
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-sold') || btn.classList.contains('is-loading')) return;
      var id = btn.dataset.variantId; if (!id) return;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      btn.classList.add('is-loading');
      ajaxAdd(id, qty).then(function (r) { return r.json(); }).then(function (data) {
        btn.classList.remove('is-loading');
        pubCartUpdate('sowth-pdp', id, data);
        refreshCartBubble();
        if (window.SowthDrawer) { window.SowthDrawer.refresh(); }
        else { window.location.href = root.getAttribute('data-cart-url') || '/cart'; }
      }).catch(function () { btn.classList.remove('is-loading'); window.location.href = '/cart'; });
    });
  }
  wireAtc(atc, $('.qty input'));
  wireAtc(stickyAtc, null);

  /* ---------- sticky bar visibility ---------- */
  var bar = $('[data-stickybar]'), anchor = $('.buyrow');
  if (bar && anchor && 'IntersectionObserver' in window) {
    var sio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { bar.classList.remove('show'); }
        else if (e.boundingClientRect.top < 0) { bar.classList.add('show'); }
      });
    }, { threshold: 0 });
    sio.observe(anchor);
  }

  /* ---------- size guide ---------- */
  var dlg = $('[data-sizeguide-dialog]');
  $all('[data-sizeguide-open]').forEach(function (b) { b.addEventListener('click', function () { if (dlg && dlg.showModal) dlg.showModal(); }); });
  $all('[data-sizeguide-close]').forEach(function (b) { b.addEventListener('click', function () { if (dlg) dlg.close(); }); });
  if (dlg) dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });

  /* ---------- lightbox ---------- */
  var lb = $('[data-lightbox]'), lbImg = lb ? lb.querySelector('img') : null;
  function openLb(src) { if (!lb) return; lbImg.setAttribute('src', src); lb.classList.add('show'); }
  $all('[data-zoom]').forEach(function (z) { z.addEventListener('click', function () { if (mainImg) openLb(mainImg.getAttribute('src')); }); });
  $all('[data-lb-close]').forEach(function (b) { b.addEventListener('click', function () { if (lb) lb.classList.remove('show'); }); });
  if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) lb.classList.remove('show'); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb) lb.classList.remove('show'); });

  /* ---------- delivery ETA (dispatch 1–3 + transit 7–12 business days) ---------- */
  (function () {
    var el = $('[data-eta]'); if (!el) return;
    function biz(start, n) { var d = new Date(start.getTime()), a = 0; while (a < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) a++; } return d; }
    function fmt(d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); }
    var now = new Date(), lo = biz(now, 8), hi = biz(now, 15);
    var r = el.querySelector('[data-eta-range]'); if (r) r.textContent = fmt(lo) + ' to ' + fmt(hi);
    el.hidden = false;
  })();

  /* ---------- cross-sell quick add (single-variant cards in the fallback row) ---------- */
  $all('.xsell .s-add[data-variant-id]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.classList.contains('added') || b.classList.contains('loading')) return;
      var id = b.getAttribute('data-variant-id'); if (!id) return;
      b.classList.add('loading');
      ajaxAdd(id, 1).then(function (r) { return r.json(); }).then(function (data) {
        b.classList.remove('loading'); b.classList.add('added'); b.innerHTML = '✓';
        pubCartUpdate('sowth-pdp-xsell', id, data);
        refreshCartBubble();
        document.dispatchEvent(new CustomEvent('sowth:cart:added'));
        setTimeout(function () { b.classList.remove('added'); b.innerHTML = '+'; }, 1500);
      }).catch(function () { b.classList.remove('loading'); window.location.href = '/cart'; });
    });
  });
})();
